document.querySelector('variant-selects').addEventListener('change',function(){
    var id = document.querySelector('variant-selects').currentVariant.id
    var price = document.querySelector('variant-selects').currentVariant.price;
    var av = document.querySelector('variant-selects').currentVariant.available
    var image =   document.querySelector('variant-selects').currentVariant.featured_image.src
    $('button.custom_addtocart').attr('var_id',id);
    function formatNumberWithCommas(number) {
        var parts = number.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join('.');
    }
var formattedPrice = (price / 100).toFixed(2);
var currency = Shopify.currency.active;
var formattedPriceWithCommas = formatNumberWithCommas(formattedPrice);
if (currency === 'INR') {
    $('.product_price_noty').html('Rs ' + formattedPriceWithCommas);
} else if (currency === 'USD') {
    $('.product_price_noty').html('$ ' + formattedPriceWithCommas);
}
  if(av == false){
    $('.custom_addtocart').addClass('sold-out');
     $('.custom_addtocart span').text('sold-out');
    }else{
    $('.custom_addtocart').removeClass('sold-out');
     $('.custom_addtocart span').text('Add to cart');
    }    
    if(image != ''){
    $('.main_img_cart img').attr('src',image)
    }  
});